export const HOURS_OPTIONS = Array.from({length: 24}, (_, i) => ({
  label: ('0' + i).slice(-2),
  value: i
}));

export const MINUTES_OPTIONS = Array.from({length: 60}, (_, i) => ({
  label: ('0' + i).slice(-2),
  value: i
}));
